import BaseAPI from "@/apis/base/base-api";
import commonFn from "@/commons/commonFunction";
class TransactionControlReportAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Management";
  controllerName = "mc/merchanttransactioncontrolreports";

  /**
   * Lấy dữ liệu danh sách giao dịch
   */
  getList(payload) {
    let filter = payload.filter ? `${payload.filter}` : "";
    var param = {
      SkipCount: payload.skip || 0,
      MaxResultCount: payload.take || 20,
      Filter: filter,
      Sorting: payload.Sort || null,
      StartDate: payload.fromDate,
      EndDate: payload.toDate,
    };

    let request = {
      url: this.getAPIUrl() + "/merchants/list",
      data: param,
    };
    return this.postAsync(request);
  }
}

export default new TransactionControlReportAPI();
